import * as React from 'react';
import { AddDocumentItemOptions } from 'app/infrastructure/ui/form/types';
import { ComplexValue } from 'ui';
import { PreselectedCodeTileViewProps, PreselectedCodeTileView } from 'app/area/case/components';
import { MultiSelectReferenceModal } from './multi-select-reference-modal';
import { StoreField } from 'app/types-shared';
import { Translations } from 'ui/common/select/types';

import type { JSX } from "react";

export interface ReferenceSelectTileViewTranslations extends Translations {
  textMultiSelectOptionsModalTitle: string;
}

export interface ReferenceSelectTileViewProps extends PreselectedCodeTileViewProps, ReferenceSelectTileViewTranslations {
  fetchingModalOptions: boolean;
  referenceModalOptions: ComplexValue<number>[];
  referenceOptionDataTag: string;
  extraFooterButton?: (onCloseCallback: (onClose: void) => void) => JSX.Element;
  textManageOptions?: string;
  referenceOptionCodetableId?: string;
}

export interface ReferenceSelectTileViewState {
  multipleSelectReferencesToBeAdded: ComplexValue<number>[];
}

export class ReferenceSelectTileView extends React.PureComponent<ReferenceSelectTileViewProps, any> {

  public state: Readonly<any> = {
    multipleSelectReferencesToBeAdded: []
  };

  private onAddReference = (selectAddedItem?: boolean, options?: AddDocumentItemOptions) => {

    const { codeDataTag } = this.props;

    const codeValue = options.initialValues && options.initialValues[codeDataTag] as StoreField[];

    // Special handling of multiple select reference type.
    if(codeValue && codeValue[0] && codeValue[0].categoryId === 5) {
      this.setState((prevState) => ({
        ...prevState,
        multipleSelectReferencesToBeAdded: [
          ...prevState.multipleSelectReferencesToBeAdded,
          codeValue[0]
        ]
      }));
    }
    else {
      this.props.onAddDocumentItem(selectAddedItem, options);
    }
  };

  private clearMultipleSelectReferencesToBeAdded = () => {
    this.setState({
      ...this.state,
      multipleSelectReferencesToBeAdded: []
    });
  };

  public render() {
    const { multipleSelectReferencesToBeAdded } = this.state;
    const {
      codeDataTag: referenceCodeDataTag,
      onLoadOptions, onAddDocumentItem,
      textDone: textOptionsDone, placeholderSearch,
      textMultiSelectOptionsModalTitle,
      extraFooterButton,
      textManageOptions,
      locale
    } = this.props;

    const multipleSelectModal =
      multipleSelectReferencesToBeAdded && multipleSelectReferencesToBeAdded.length > 0 &&
      <MultiSelectReferenceModal
        {...this.props}
        textTitle={textMultiSelectOptionsModalTitle}
        textOptionsDone={textOptionsDone}
        textPlaceholderSearch={placeholderSearch}
        multipleSelectReferencesToBeAdded={multipleSelectReferencesToBeAdded}
        referenceCodeDataTag={referenceCodeDataTag}
        onClose={this.clearMultipleSelectReferencesToBeAdded}
        onDone={this.clearMultipleSelectReferencesToBeAdded}
        onLoadOptions={onLoadOptions}
        onAddDocumentItem={onAddDocumentItem}
        textManageOptions={textManageOptions}
        locale={locale}
      />;

    return (
      <>
        {multipleSelectModal}
        <PreselectedCodeTileView {...this.props}
          onAddDocumentItem={this.onAddReference}
          existingKeys={[]}
          rowClassName={this.props.rowClassName || 'col-md-6 col-xl-4'}
          extraFooterButton={extraFooterButton}
        />
      </>
    );
  }
}
